<template>
  <v-card flat class="pa-2" v-if="ticket.chat_messages && ticket.chat_messages.length">
    <v-layout row wrap>
      <v-flex 
        xs12 
        md12 
        :class="`d-flex ${message.user_id === current_user.id ? 'justify-end' : ''}`" 
        v-for="(message, i) in ticket.chat_messages" :key="i"
      >
        <template v-if="message.is_system_message">
          <!-- Mensaje del sistema -->
          <v-flex xs12 class="d-flex justify-center my-4">
            <p class="system-message">
              {{ message.content }} - {{ message.created_at }}
            </p>
          </v-flex>
        </template>
        <template v-else>
          <!-- Mensajes normales -->
          <v-flex xs12 md5>
            <v-card :color="colorItem(message)">
              <v-card-text class="pa-1 mb-1">
                <p class="ma-0" v-html="message.content"></p>
                <ul v-for="(file, index) in message.files" :key="index">
                  <li>
                    <a :href="file.url" :class="colorItem(message)">
                      {{ file.name }}
                    </a>
                  </li>
                </ul>
              </v-card-text>
            </v-card>
            <p v-if="message.user_id === current_user.id" class="caption">
              {{ `Yo - ${message.created_at}` }}
            </p>
            <p v-else>
              {{ `${message.user_name} - ${message.created_at}` }}
            </p>
          </v-flex>
        </template>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    ticket: { type: Object, required: true }
  },
  computed: {
    ...mapState("user", ["current_user"]),
  },
  methods: {
    colorItem(message) {
      return `${message.user_id === this.current_user.id ? 'indigo white--text' : 'indigo lighten-5'}`
    },
  },
}
</script>
<style>
.system-message {
  color: grey;
  text-align: center;
}
</style>

